// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"c9-z"};